/**
 * ⚠️ WE NEED TO REVIEW THIS PERIODICALLY ⚠️
 *
 * Currently, we support only the last 2 major versions of each browser.
 */

const MIN_SUPPORTED_VERSIONS: Record<string, number> = {
  chrome: 110,
  edge: 148,
  firefox: 115,
  safari: 16,
}

interface IMatcher {
  name: string
  pattern: RegExp
}

interface BrowserInfo {
  name: string
  version: number
}

export function detectBrowser(
  userAgent: string = navigator.userAgent
): BrowserInfo | null {
  const REGEX_CHROME = /(?:Chrome|CriOS)\/(\d+)/
  const REGEX_FIREFOX = /(?:Firefox|FxiOS)\/(\d+)/
  const REGEX_EDGE = /Edg(?:e|A|iOS)?\/(\d+)/
  const REGEX_SAFARI = /Version\/(\d+).*Safari/

  const matchers: IMatcher[] = [
    // Edge must come before Chrome (Edge UA contains "Chrome")
    { name: 'edge', pattern: REGEX_EDGE },
    // Also matches Opera which is Chromium based
    { name: 'chrome', pattern: REGEX_CHROME },
    { name: 'firefox', pattern: REGEX_FIREFOX },
    // Safari must come last because many browsers include "Safari" in their UA
    { name: 'safari', pattern: REGEX_SAFARI },
  ]

  for (const matcher of matchers) {
    const match = userAgent.match(matcher.pattern)

    if (match) {
      return {
        name: matcher.name,
        version: parseInt(match[1], 10),
      }
    }
  }

  return null
}

export function isBrowserSupported(
  userAgent: string = navigator.userAgent
): boolean {
  const browser = detectBrowser(userAgent)

  // Permit unknown browser
  if (!browser) {
    return true
  }

  const minVersion = MIN_SUPPORTED_VERSIONS[browser.name]

  // Permit known browsers where the version could not be ascertained
  if (minVersion === undefined) {
    return true
  }

  return browser.version >= minVersion
}
